import React, { Component } from 'react';

import ExportCSV from '../Helper/Grid/ExportCSV'
import Grid from '../Helper/Grid'
import GridFilter from '../Helper/GridFilter'
import Client from '../Entity/Client'

/**
* Class ClientList
* ClientList view component
**/
class ClientList extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const objectClass = Client;

    // Filter list
    const filters = [{
      title: "Nom du client",
      type: "text",
      name: "libelle",
      rowIdx: 1
    }];

    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer mes clients</h2>
        <GridFilter title="Filtrer les clients" objectClass={objectClass.getClassName()} filters={filters} parent={this} formattedFilters={true} />
        <Grid title="Clients" ref="gridClient" path="clients" objectPath="clients" objectClass={objectClass} height="400px" hidden={false} />
        <ExportCSV parent={this} gridRef="Client"
          fields={["Raison sociale/Nom", "numeroTiers", "adresse", "codePostal", "ville", "commentaire",
          { fieldName: "contactPrincipal", extrafields: ["nom"], title: "Nom du contact" },
          { fieldName: "contactPrincipal", extrafields: ["prenom"], title: "Prénom du contact" },
          { fieldName: "contactPrincipal", extrafields: ["telephone"], title: "Téléphone du contact" },
          { fieldName: "contactPrincipal", extrafields: ["email1"], title: "Mail du contact" }]} />
      </div>
		);
	}

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const grid = this.refs["gridClient"];
    grid.applyFilter(fieldName, value);
  }

  /**
  * applyDateFilter
  * Filters the grid
  **/
  applyDateFilter(filterField, dateValue, comparatorValue) {
    const grid = this.refs["gridClient"];
    grid.applyDateFilter(filterField, dateValue, comparatorValue);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const grid = this.refs["gridClient"];
    grid.clearFilters();
  }

}
export default ClientList;



// WEBPACK FOOTER //
// ./src/views/Search/ClientList.js